export default {
  article         : state => state.article,
  articleLoading  : state => state.articleLoading,
  comments        : state => state.comments,
  commentsLoading : state => state.commentsLoading,
  commentsWaiting : state => state.commentsWaiting,
}
